import React from "react";
import Waypoint from "react-waypoint";
export class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInView: true
    };
  }
  componentDidMount() {
    if (window && window.innerWidth > 559) {
      window.addEventListener("resize", this.dummyOnLeave);
      window.addEventListener("resize", this.dummyOnEnter);
    }
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.dummyOnLeave);
      window.removeEventListener("resize", this.dummyOnEnter);
    }
  }
  dummyOnLeave = ({ currentPosition }) => {
    if (window && window.innerWidth > 559) {
      if (currentPosition === Waypoint.above) {
        this.setState({ isInView: false });
      }
    }
  };
  dummyOnEnter = ({ currentPosition }) => {
    if (window && window.innerWidth > 559) {
      if (currentPosition === Waypoint.inside) {
        this.setState({ isInView: true });
      }
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.filteredProjects !== this.props.filteredProjects) {
    }
  }
  render() {
    this.filterArr = [];
    this.findFilter = this.props.filteredProjects.map((project, index) =>
      this.filterArr.push(project.acf.type)
    );
    


    var uniq = this.filterArr.reduce(function(a,b){
      if (a.indexOf(b) < 0 ) a.push(b);
      return a;
    },[]);


    this.uniqeFilterArr = uniq


    this.filter = this.uniqeFilterArr.map((filter, index) => (
      <li
        key={index}
        className={this.props.singleFilerClass ? "single-item" : null}
      >
        <button
          onClick={this.props.handleFilter}
          value={filter}
          className={this.props.isFiltered ? "active" : ""}
        >
          {filter}
        </button>
      </li>
    ));
    return (
      <div>
        {this.state.isInView && (
          <Waypoint onLeave={this.dummyOnLeave} scrollableAncestor={window}>
            <div
              style={{
                width: "10px",
                position: "absolute",
                top: "112px",
                height: "10px",
                background: "transparent"
              }}
            />
          </Waypoint>
        )}
        {!this.state.isInView && (
          <Waypoint onEnter={this.dummyOnEnter} scrollableAncestor={window}>
            <div
              style={{
                width: "100%",
                maxWidth: "1200px",
                position: "absolute",
                top: "0",
                height: "112px"
              }}
            />
          </Waypoint>
        )}

        <div
          className={
            this.state.isInView ? "filters-wrap" : "filters-wrap sticky"
          }
          style={{
            width: this.props.isFiltered ? this.props.filtersWidth : null
          }}
        >
          <ul className="filters" style={{}}>
            {this.filter}
          </ul>
          {this.props.isFiltered && (
            <button
              onClick={this.props.handleCloseBtn}
              className="close-filters"
            >
              <span />
              <span />
            </button>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Filters.js